<section class="aw-karte" aria-labelledby="aw-titel">
  <div class="aw-karte__kopf">
    <div class="aw-karte__titel">
      <to-section-title
        headingId="aw-titel"
        [title]="'auswahllisten.titel' | translate"
        [subtitle]="'auswahllisten.modus.' + modus() + '.untertitel' | translate"
      />
    </div>
    @if (!istProjekt()) {
      <span class="aw-pille" [class.aw-pille--angepasst]="anzahlAngepasst() > 0" data-testid="aw-pille-gesamt">
        @if (anzahlAngepasst() > 0) {
          {{ 'auswahllisten.pilleAngepasst' | translate: { n: anzahlAngepasst(), gesamt: listen().length } }}
        } @else {
          {{ 'auswahllisten.pilleStandard' | translate }}
        }
      </span>
    }
  </div>

  <div class="aw-karte__raster">
    <div class="aw-liste">
      <div class="aw-liste__suche">
        <app-search-bar
          data-testid="aw-suche"
          [placeholder]="'auswahllisten.suche' | translate"
          [(value)]="suche"
          (keydown.enter)="$event.preventDefault()"
        />
      </div>
      <div role="listbox" [attr.aria-label]="'auswahllisten.listeAria' | translate">
        @for (gruppe of gruppen(); track gruppe.bereich) {
          <div role="group" [attr.aria-labelledby]="'aw-gruppe-' + gruppe.bereich">
            <div class="aw-liste__gruppe" [id]="'aw-gruppe-' + gruppe.bereich">
              {{ 'auswahllisten.bereich.' + gruppe.bereich | translate }}
            </div>
            @for (liste of gruppe.listen; track liste.listKey) {
              @let gewaehlt = liste.listKey === aktiv()?.listKey;
              <button
                type="button"
                role="option"
                class="aw-eintrag"
                [class.aw-eintrag--aktiv]="gewaehlt"
                [attr.aria-selected]="gewaehlt"
                [attr.data-testid]="'aw-liste-' + liste.listKey"
                (click)="waehlen(liste.listKey)"
              >
                <span class="aw-eintrag__text">
                  <span class="aw-eintrag__name">{{ nameSchluessel(liste.listKey) | translate }}</span>
                  <span class="aw-eintrag__anzahl">
                    {{
                      (liste.werte.length === 1 ? 'auswahllisten.anzahlEins' : 'auswahllisten.anzahl')
                        | translate: { n: liste.werte.length }
                    }}
                  </span>
                </span>
                @if (liste.angepasst && !istProjekt()) {
                  <span class="aw-eintrag__badge" data-testid="aw-badge-angepasst">
                    {{ 'auswahllisten.badge' | translate }}
                  </span>
                }
              </button>
            }
          </div>
        }
      </div>
      @if (!laedt() && suche().trim() && gruppen().length === 0) {
        <p class="aw-liste__leer" data-testid="aw-suche-leer">{{ 'auswahllisten.sucheLeer' | translate }}</p>
      }
    </div>

    <div class="aw-editor">
      @if (laedt()) {
        <p class="aw-editor__laedt" role="status" data-testid="aw-laedt">{{ 'auswahllisten.laedt' | translate }}</p>
      } @else if (aktiv(); as liste) {
        <div class="aw-editor__kopf">
          <div class="aw-editor__titel">
            <div class="aw-editor__bereich">{{ 'auswahllisten.bereich.' + liste.bereich | translate }}</div>
            <div class="aw-editor__name">{{ nameSchluessel(liste.listKey) | translate }}</div>
            <div class="aw-editor__verwendet">
              {{ 'auswahllisten.verwendetIn' | translate: { wo: (verwendetSchluessel(liste.listKey) | translate) } }}
            </div>
          </div>
          @if (!istProjekt()) {
            <span class="aw-pille" [class.aw-pille--angepasst]="liste.angepasst" data-testid="aw-pille-liste">
              {{
                (liste.angepasst ? 'auswahllisten.modus.' + modus() + '.angepasst' : 'auswahllisten.standardwerte')
                  | translate
              }}
            </span>
          }
        </div>

        <div class="aw-werte" cdkDropList (cdkDropListDropped)="fallenLassen($event)">
          @for (wert of liste.werte; track $index; let i = $index) {
            <div class="aw-zeile" cdkDrag>
              <div class="aw-zeile__inhalt">
                <button
                  #griff
                  type="button"
                  class="aw-zeile__griff"
                  cdkDragHandle
                  [title]="'auswahllisten.griffTitel' | translate"
                  [attr.aria-label]="'auswahllisten.griffAria' | translate: { wert: wert.value }"
                  (keydown)="griffTaste(i, $event)"
                >
                  <span aria-hidden="true">⠿</span>
                </button>
                @if (istStatus()) {
                  <span class="aw-kategorie" [attr.data-kategorie]="wert.category">
                    <span class="aw-kategorie__punkt" aria-hidden="true"></span>
                    <select
                      class="aw-kategorie__auswahl"
                      [attr.aria-label]="'auswahllisten.kategorieAria' | translate: { wert: wert.value }"
                      (change)="kategorieSetzen(i, $any($event.target).value)"
                    >
                      @for (kategorie of kategorien; track kategorie) {
                        <option [value]="kategorie" [selected]="kategorie === wert.category">
                          {{ 'auswahllisten.kategorie.' + kategorie | translate }}
                        </option>
                      }
                    </select>
                  </span>
                }
                <input
                  type="text"
                  class="aw-zeile__eingabe"
                  [class.aw-zeile__eingabe--fehler]="fehler()[i]"
                  [attr.maxlength]="wertMax"
                  [value]="wert.value"
                  [attr.aria-label]="'auswahllisten.wertAria' | translate: { n: i + 1 }"
                  [attr.aria-invalid]="fehler()[i] ? 'true' : null"
                  [attr.aria-describedby]="fehler()[i] ? 'aw-wert-fehler-' + i : null"
                  [attr.data-testid]="'aw-wert-' + i"
                  (input)="umbenennen(i, $any($event.target).value)"
                  (change)="festlegen(i)"
                  (keydown.enter)="wertTaste(i, $event)"
                />
                @if (!istProjekt() || liste.werte.length > 1) {
                  <button
                    type="button"
                    class="aw-zeile__loeschen"
                    [disabled]="liste.werte.length <= 1"
                    [title]="'auswahllisten.entfernenTitel' | translate"
                    [attr.aria-label]="'auswahllisten.entfernenAria' | translate: { wert: wert.value }"
                    (click)="entfernen(i)"
                  >
                    <mat-icon aria-hidden="true">delete</mat-icon>
                  </button>
                }
              </div>
              @if (fehler()[i]; as fehlerText) {
                <p
                  class="aw-fehler aw-zeile__fehler"
                  [id]="'aw-wert-fehler-' + i"
                  [attr.data-testid]="'aw-wert-fehler-' + i"
                >
                  {{ fehlerText | translate }}
                </p>
              }
            </div>
          }
        </div>

        <div class="aw-neu">
          <input
            type="text"
            class="aw-neu__eingabe"
            [class.aw-neu__eingabe--doppelt]="doppelt()"
            [attr.maxlength]="wertMax"
            [value]="neu()"
            [placeholder]="'auswahllisten.neuPlatzhalter' | translate"
            [attr.aria-label]="'auswahllisten.neuAria' | translate"
            [attr.aria-describedby]="doppelt() ? 'aw-doppelt' : null"
            data-testid="aw-wert-neu"
            (input)="neu.set($any($event.target).value)"
            (keydown)="neuTaste($event)"
          />
          <button
            type="button"
            class="aw-neu__knopf"
            data-testid="aw-hinzufuegen"
            [disabled]="!kannHinzufuegen()"
            (click)="hinzufuegen()"
          >
            {{ 'auswahllisten.hinzufuegen' | translate }}
          </button>
        </div>
        @if (doppelt()) {
          <p id="aw-doppelt" class="aw-fehler aw-neu__fehler" data-testid="aw-doppelt">
            {{ 'auswahllisten.fehler.doppelt' | translate }}
          </p>
        }
        @if (listenFehler(); as listenFehlerText) {
          <p class="aw-fehler aw-editor__listenfehler" data-testid="aw-listenfehler">
            {{ listenFehlerText | translate }}
          </p>
        }

        <div class="aw-editor__fuss">
          <span class="aw-editor__hinweis">{{ 'auswahllisten.modus.' + modus() + '.hinweis' | translate }}</span>
          @if (!istProjekt()) {
            <button
              type="button"
              class="aw-editor__zuruecksetzen"
              data-testid="aw-zuruecksetzen"
              [disabled]="!abweichendVomStandard()"
              (click)="fragen.set(true)"
            >
              {{ 'auswahllisten.zuruecksetzen' | translate }}
            </button>
          }
        </div>
      }
      <div class="sr-only" aria-live="polite" data-testid="aw-ansage">{{ ansage() }}</div>
    </div>
  </div>
</section>

@if (!istProjekt()) {
  <app-confirm-dialog
    [visible]="fragen()"
    [title]="'auswahllisten.rueckfrage.titel' | translate"
    [message]="
      'auswahllisten.rueckfrage.text'
        | translate: { name: aktiv() ? (nameSchluessel(aktiv()!.listKey) | translate) : '' }
    "
    [confirmLabel]="'auswahllisten.rueckfrage.bestaetigen' | translate"
    [cancelLabel]="'auswahllisten.rueckfrage.abbrechen' | translate"
    icon="restart_alt"
    iconTon="akzent"
    confirmColor="primary"
    (confirmed)="zuruecksetzen()"
    (cancelled)="fragen.set(false)"
  />
}
